module.exports = __webpack_public_path__ + "img/Facebook.32192a95.svg";